import { useTranslationRankmi } from '../../../../../../../helpers/translations.helper'
import { prefixTranslation } from '../common'

export const usePrefixTranslation = () =>
  useTranslationRankmi({
    prefix: prefixTranslation,
  })

export * from './filtersColumns'
